import books from "../api/fake.api/book.api";
import genres from "../api/fake.api/genres";
import authors from "../api/fake.api/authors";
import users from "./fake.api/users";
import rentedBooks from "./fake.api/rentedBooks";
import purchasedBooks from "./fake.api/purchasedBooks";

const API = {
    books,
    genres,
    authors,
    users,
    rentedBooks,
    purchasedBooks
};
export default API;
